import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { constant } from '@login/resources/constant';
import { ApiConstants } from '@login/util/api-constants';
import { SpinnerService } from '@shared/services/spinner.service';
import { AlertService } from '@shared/services/alert.service';

const UNEXPECTED_ERROR_MSG =
  'An unexpected error has occurred. Please try again later.';
@Component({
  selector: 'app-mfa-challenge',
  templateUrl: './mfa-challenge.component.html',
  styleUrls: ['./mfa-challenge.component.scss'],
})
export class MfaChallengeComponent implements OnInit {
  showErrorMsg = true;
  errorMessage: string;

  constructor(
    private router: Router,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {}

  onVerifyRecoveryAnswerSuccess(res) {
    this.alertService.clearAlert();
    this.spinnerService.stop();
    if (res.ok) {
      this.router.navigate(['/login/authentication-setup'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      this.router.navigate(['login'], { queryParamsHandling: 'preserve' });
    }
  }

  onVerifyRecoveryAnswerError(err) {
    let alertMessage;
    switch (err.error.errorCode) {
      case 'ERRPRS023':
        alertMessage = ApiConstants.CHALLENGE_ANSWER_ERROR;
        break;
      case 'ERRPRS020':
        alertMessage = ApiConstants.ACCOUNT_LOCKED_ERROR;
        break;
      case 'ERRPRS025':
        alertMessage = ApiConstants.INVALID_STATE_TOKEN_ERROR;
        break;
      case 'ERRPRS024':
      case 'ERRPRS010':
      case 'ERRPRS011':
        alertMessage = err.error.statusText;
        break;
      default:
        alertMessage = constant.ON_VRFY_REC_ANS_CALL_FAILURE_1;
        break;
    }
    this.alertService.setAlert(alertMessage);
    this.spinnerService.stop();
  }

  onIsValidRecoveryToken({ isValid, err }) {
    this.alertService.clearAlert();
    this.showErrorMsg = isValid;
    if (err?.error?.errorCode === 'E0000034') {
      this.errorMessage = constant.FORGOT_PWD_UNSUPPORTED_EUA_USER;
    } else if (err?.error.errorCause?.[0]?.errorSummary) {
      this.errorMessage = err.error.errorCause[0].errorSummary;
    } else if (err?.error?.statusText) {
      this.errorMessage = err.error.statusText;
    } else if (err?.errorMessage) {
      this.errorMessage = err.errorMessage;
    } else {
      this.errorMessage = UNEXPECTED_ERROR_MSG;
    }
  }
}
